import React, { useEffect, useState } from 'react'
import { useFieldArray, useForm } from 'react-hook-form'
import { Col, Container, FormGroup, Label,Row, Form, Button, Input, Spinner, Alert } from 'reactstrap'
import { CiTrash } from "react-icons/ci";
import { FaTrashAlt } from "react-icons/fa";
import useAddOrders from './useAddOrders';
import useEditOrders from './useEditOrders';
import { MdAdd } from "react-icons/md";
import useInitialData from 'context/useInitialData';
import { useWebSocket } from 'context/WebSocketContext';
import { useQueryClient } from '@tanstack/react-query';

const SingleOrderForm = ({isEditMode, orderData, onSuccess}) => {

    const queryClient = useQueryClient()

    // getting the wallet data from local storage
    const userData = JSON.parse(localStorage.getItem('userData'))
    const credits = Number(userData?.wallet?.free_credit) + Number(userData?.wallet?.debt_credit) + Number(userData?.wallet?.paid_credit);

    const {walletData} = useWebSocket();
    console.log("wallet",walletData)

    const creds = walletData ? Number(walletData.total_balance) : credits;
    console.log("credits",creds)

    const {data:initData} = useInitialData();
    const products = initData?.products || []

    const totalProductPrice = products.reduce((sum,product)=>sum + parseFloat(product.current_price?.price || 0),0 )

    // custom hook for adding orders
    const{isPending, isSuccess, addOrders} = useAddOrders();
    // custom hook for editing orders
    const{isEditing, isEdited, editOrder}=useEditOrders();
    // getting data from local storage
    // state
    const[states, setStates] = useState([]);
    // county
    const[counties,setCounties] = useState([]);
    // for managing the same as current owner check box
    const[isSameOwner, setIsSameOwner]=useState(false)

    useEffect(()=>{
        const cachedData =localStorage.getItem('appInitData')
        if(cachedData){
            const parsedData = JSON.parse(cachedData);
            setStates(parsedData.state || [])
            setCounties(parsedData.county || [])
        }
    },[])

    const{register,handleSubmit,formState:{errors},control, reset,setValue,clearErrors,trigger,watch}=useForm({
        defaultValues:{
            filenumber:"",
            loannumber:"",
            clientname:"",
            lendercontact:'',
            lenderaddress:'',
            producttype:"",
            borrowername:"",
            issameasowner:"",
            streetnumber:"",
            streetprefix:"",
            streetname:"",
            streettype:"",
            streetsuffix:"",
            unit:"",
            state:"",
            county:"",
            city:"",
            zip:"",
            apn:"",
            // for static owner name field
            firstname:"",
            middlename:"",
            lastname:"",
            // this is for additional owner field
            owners:[]
        },
        criteriaMode:"all",
        mode:"onChange"
    })

    const {fields, append, remove}=useFieldArray({
        control,
        name:"owners"
    })
    // for clearing the value and validation error if checkbox is selcted
    useEffect(()=>{
        if(isSameOwner){
            setValue("borrowername","")
            clearErrors("borrowername")
        }
        // else{
        //     trigger("borrowername")
        // }
    },[isSameOwner,setValue,clearErrors,trigger])

    // when editing, polpulate from the existing data
    // useEffect(()=>{
    //     if(isEditMode && orderData){
    //         console.log("order data for editing:", orderData)

    //         // owners
    //         const[primaryOwner, ...additionalOwners] = orderData.owners || [{},[]]
    //         // for address
    //         const addressData = orderData.address || {};
    //         console.log("address only", addressData)
    //         // same owner
    //         const sameOwner =  orderData.is_same_asowner === 1;

    //         // set local state for disabling the validation control
    //         setIsSameOwner(sameOwner);

    //         const formValues = {
    //             apn: orderData.apn,
    //             filenumber: orderData.file_num,
    //             loannumber: orderData.loan_number,
    //             clientname: orderData.client_name,
    //             lendercontact: orderData.lender_contact,
    //             lenderaddress: orderData.lender_address,
    //             borrowername: orderData.borrower_name || '',
    //             issameasowner: sameOwner,
    //             producttype: orderData.product_type,

    //             city: addressData.city,
    //             county: addressData.county,
    //             state: addressData.state,
    //             streetname: addressData.street_name,
    //             streetnumber: addressData.street_number,
    //             streetprefix: addressData.street_prefix,
    //             streetsuffix: addressData.street_suffix,
    //             streettype: addressData.street_type,
    //             unit: addressData.unit_number,
    //             zip: addressData.zip,

    //             firstname: primaryOwner?.first_name || '',
    //             middlename: primaryOwner?.middle_name || '',
    //             lastname: primaryOwner?.last_name || '',

    //             owners: additionalOwners.map(owner=>({
    //                 firstname : owner.first_name || '',
    //                 middlename: owner.middle_name || '',
    //                 lastname: owner.last_name || ''
    //             })),
    //         }
            
    //         console.log("data before reseting the form for updating",formValues)
    //         console.log(
    //             "Reset county:",
    //             addressData.county,
    //             typeof addressData.county
    //         );
    //         reset(formValues)

    //         setTimeout(() => {
    //             console.log("watch county:", watch("county"));
    //             console.log("watch state:", watch("state"));
    //         }, 0);
    //     }
    //     else{
    //         setIsSameOwner(false) //resetting the check box logic tooo
    //         reset();
    //     }
    // },[isEditMode, orderData, reset])

    useEffect(() => {
        if (isEditMode && orderData) {
            // wait until dropdown options actually exist
            if (states.length === 0 || counties.length === 0) return;

            const [primaryOwner, ...additionalOwners] = orderData.owners || [{}, []]
            const addressData = orderData.address || {};
            const sameOwner = orderData.is_same_asowner === 1;

            setIsSameOwner(sameOwner);

            const formValues = {
                apn: orderData.apn,
                filenumber: orderData.file_num,
                loannumber: orderData.loan_number,
                clientname: orderData.client_name,
                lendercontact: orderData.lender_contact,
                lenderaddress: orderData.lender_address,
                borrowername: orderData.borrower_name || '',
                issameasowner: sameOwner,
                producttype: orderData.product_type,

                city: addressData.city,
                county: addressData.county != null ? String(addressData.county) : '',
                state: addressData.state != null ? String(addressData.state) : '',
                streetname: addressData.street_name,
                streetnumber: addressData.street_number,
                streetprefix: addressData.street_prefix,
                streetsuffix: addressData.street_suffix,
                streettype: addressData.street_type,
                unit: addressData.unit_number,
                zip: addressData.zip,

                firstname: primaryOwner?.first_name || '',
                middlename: primaryOwner?.middle_name || '',
                lastname: primaryOwner?.last_name || '',

                owners: additionalOwners.map(owner => ({
                    firstname: owner.first_name || '',
                    middlename: owner.middle_name || '',
                    lastname: owner.last_name || ''
                })),
            }

            reset(formValues)
        } else if (!isEditMode) {
            setIsSameOwner(false)
            reset();
        }
    }, [isEditMode, orderData, reset, states, counties])

    const onSubmit=(data)=>{

        const primaryOwner={
            first_name: data.firstname,
            middle_name: data.middlename,
            last_name: data.lastname
        };

        // mapping additional owner
        const additionalOwners = data.owners.map(owner=>({
            first_name: owner.firstname,
            middle_name: owner.middlename,
            last_name: owner.lastname
        }));

        // combing both the owners
        const allowners = [primaryOwner, ...additionalOwners]

        // check box for is same owner
        const isSameAsOwner = data.issameasowner ? 1:0;
        
        // the borrower name
        const borrowerName = isSameAsOwner ? null : data.borrowername;

        const payload = {
            file_num: data.filenumber,
            loan_number: data.loannumber,
            client_name: data.clientname,
            lender_contact: data.lendercontact,
            lender_address: data.lenderaddress,
            product_type: data.producttype,
            borrower_name: borrowerName,
            is_same_asowner: isSameAsOwner,
            apn: data.apn,
            address: {
                street_number: data.streetnumber,
                street_name: data.streetname,
                street_prefix: data.streetprefix,
                street_suffix: data.streetsuffix,
                street_type: data.streettype,
                unit_number: data.unit,
                state: data.state,
                county: data.county,
                city: data.city,
                zip: data.zip   
            },

            owners: allowners,

            ...(isEditMode && { order_id: orderData.order_id }) // 
        }

        if(isEditMode){
            console.log("editing done",data)
            editOrder(payload,{
                onSuccess:()=>{
                    onSuccess();
                }
            })
        }else{
            console.log("adding done",payload)
            addOrders(payload,{
                onSuccess:()=>{
                    onSuccess();
                    queryClient.invalidateQueries(["creditHistoryPerProduct"]);
                    queryClient.invalidateQueries(["creditHistory"]);
                }
            })
        }
    }

    return (
    <Container fluid>
        {/* Low balance. Please recharge. */}
        {
            creds > 0 && creds < totalProductPrice && (
                <Alert color='danger'>
                    Your credit balance is running low. Please add funds to your account.{''}
                    <a
                        className='alert-link'
                        href='/payments'
                        rel='noreferrer'
                        target='_blank'
                    >
                        Add Credits here
                    </a>
                </Alert>
            )
            
        }
        <Row>
            <Col>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <div className='mb-4 border-bottom pb-2'>
                            <h5 className='fw-bold'>Order Details</h5>
                        </div>
                        
                        <Col>
                            <FormGroup>
                                <Label htmlFor='filenumber' className='form-label'>File Number</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='filenumber'
                                    name='filenumber'
                                    placeholder='File Number'
                                    {...register("filenumber",{required:"File Number required",
                                        minLength:{value:1, message:"File Number must have atleast 5 characters"},
                                        maxLength:{value:20, message:"File Number must not exceed 10 characters"}
                                    })}
                                />
                                {errors.filenumber && <span className="text-danger">{errors.filenumber.message}</span>}
                        
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='loannumber' className='form-label'>Loan Number</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='loannumber'
                                    name='loannumber'
                                    placeholder='Loan Number'
                                    {...register("loannumber")}
                                />
                                {errors.loannumber && <span className="text-danger">{errors.loannumber.message}</span>}
                        
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='clientname' className='form-label'>Lender/Client Name</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='clientname'
                                    name='clientname'
                                    placeholder='Lender Name'
                                    {...register("clientname", {
                                        pattern:{value:/^[A-Za-z]+(?: [A-Za-z]+)*$/,message:"Name must contain only letters and a single space between words. No numbers, special characters, or leading/trailing spaces allowed."}
                                    })}
                                />
                                {errors.clientname && <span className="text-danger">{errors.clientname.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='lendercontact' className='form-label'>Lender/Client Contact</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='lendercontact'
                                    name='lendercontact'
                                    placeholder='Lender Contact'
                                    {...register("lendercontact")}
                                />
                                {errors.lendercontact && <span className="text-danger">{errors.lendercontact.message}</span>}
                            </FormGroup>
                        </Col>
                        
                    </Row>
                    
                    <Row>
                        <Col md={9}>
                            <FormGroup>
                                <Label htmlFor='lenderaddress' className='form-label'>Lender/Client Address</Label>
                                <input
                                    type='text'
                                    className='form-control border-primary-subtle'
                                    id='lenderaddress'
                                    name='lenderaddress'
                                    placeholder='Lender Address'
                                    {...register("lenderaddress")}
                                />
                                {errors.lenderaddress && <span className="text-danger">{errors.lenderaddress.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label htmlFor='producttype' className='form-label'>Product Type</Label>

                                <select
                                    className='form-select border-primary-subtle'
                                    id='producttype'
                                    name='producttype'
                                    defaultValue=""
                                    disabled={isEditMode}
                                    {...register("producttype",{required:"Product Type Required"
                                    })}
                                >
                                    <option value="" disabled>Select Product Type</option>
                                    {products.map((product,index)=>(
                                        <option key={index} value={product.product_name}>{product.product_name.startsWith("DA") ? product.product_name.replace("DA","Desktop Appraisal") : product.product_name}</option>
                                    ))}
                                </select>
                                {errors.producttype && <span className="text-danger">{errors.producttype.message}</span>}
                            </FormGroup>
                        </Col>
                    </Row>
                <Row>
                        <div className='mb-4 border-bottom pb-2'>
                            <h5 className='fw-bold'>Current Owner Details</h5>
                        </div>
                        
                            <Col>
                                {/* this row should be populated for optional owners */}
                                <Row className="align-items-end">
                                    <Col>
                                        <Row>
                                            <Col>
                                                <FormGroup>
                                                    <Label htmlFor='firstname' className='form-label'>First Name</Label>
                                                    <input
                                                        type='text'
                                                        className='form-control border-primary-subtle'
                                                        id='firstname'
                                                        name='firstname'
                                                        placeholder='First Name'
                                                        {...register("firstname",{
                                                            // pattern:{value: /^[A-Za-z]{1,30}$/, message:"First name must be letters with no spaces, numbers, or special characters."},
                                                            minLength:{value:1, message:"First Name must have atleast 1 characters."},
                                                            maxLength:{value:30, message:"First Name must have maximum 30 characters."}
                                                        })}
                                                    />
                                                    {errors.firstname && <span className="text-danger">{errors.firstname.message}</span>}
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <FormGroup>
                                                    <Label htmlFor='middlename' className='form-label'>Middle Name</Label>
                                                    <input
                                                        type='text'
                                                        className='form-control border-primary-subtle'
                                                        id='middlename'
                                                        name='middlename'
                                                        placeholder='Middle Name'
                                                        {...register("middlename",{
                                                            // pattern:{value: /^[A-Za-z]{1,30}$/, message:"Middle name must be letters with no spaces, numbers, or special characters."},
                                                            // minLength:{value:3, message:"Middle Name must have atleast 3 characters."},
                                                            maxLength:{value:30, message:"Middle Name must have maximum 30 characters."}
                                                        })}
                                                    />
                                                    {errors.middlename && <span className="text-danger">{errors.middlename.message}</span>}
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <FormGroup>
                                                    <Label htmlFor='lastname' className='form-label'>Last Name</Label>
                                                    <input
                                                        type='text'
                                                        className='form-control border-primary-subtle'
                                                        id='lastname'
                                                        name='lastname'
                                                        placeholder='Last Name'
                                                        {...register("lastname",{required:"Last Name required",
                                                            // pattern:{value: /^[A-Za-z]{1,30}$/, message:"Last name must be letters with no spaces, numbers, or special characters."},
                                                            minLength:{value:1, message:"Last Name must have atleast 3 characters."},
                                                            maxLength:{value:40, message:"Last Name must have maximum 40 characters."}
                                                        })}
                                                    />
                                                    {errors.lastname && <span className="text-danger">{errors.lastname.message}</span>}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={1}></Col>
                                </Row>
                                {/* optional owners */}
                                {fields.map((item, index) => (
                                    <Row className="align-items-end justify-content-center">
                                        <Col md={11}>
                                            <Row>
                                                <Col>
                                                    <FormGroup>
                                                        <Label htmlFor={`owners.${index}.firstname`} className="form-label">First Name</Label>
                                                        <input
                                                            type="text"
                                                            className="form-control border-primary-subtle"
                                                            placeholder="First Name"
                                                            {...register(`owners.${index}.firstname`, {
                                                                // pattern: {
                                                                //     value: /^[A-Za-z]{1,30}$/,
                                                                //     message: "First name must be letters with no spaces, numbers, or special characters.",
                                                                // },
                                                                minLength: {
                                                                    value: 1,
                                                                    message: "First Name must have at least 1 characters.",
                                                                },
                                                                maxLength: {
                                                                    value: 30,
                                                                    message: "First Name must have a maximum of 30 characters.",
                                                                },
                                                            })}
                                                        />
                                                        {errors.owners?.[index]?.firstname && (
                                                            <span className="text-danger">{errors.owners[index].firstname.message}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>

                                                <Col>
                                                    <FormGroup>
                                                        <Label htmlFor={`owners.${index}.middlename`} className="form-label">Middle Name</Label>
                                                        <input
                                                            type="text"
                                                            className="form-control border-primary-subtle"
                                                            placeholder="Middle Name"
                                                            {...register(`owners.${index}.middlename`, {
                                                                // pattern: {
                                                                //     value: /^[A-Za-z]{1,30}$/,
                                                                //     message: "Middle name must be letters with no spaces, numbers, or special characters.",
                                                                // },
                                                                minLength: {
                                                                    value: 1,
                                                                    message: "Middle Name must have at least 1 characters.",
                                                                },
                                                                maxLength: {
                                                                    value: 30,
                                                                    message: "Middle Name must have a maximum of 30 characters.",
                                                                },
                                                            })}
                                                        />
                                                        {errors.owners?.[index]?.middlename && (
                                                            <span className="text-danger">{errors.owners[index].middlename.message}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>

                                                <Col>
                                                    <FormGroup>
                                                        <Label htmlFor={`owners.${index}.lastname`} className="form-label">Last Name</Label>
                                                        <input
                                                            type="text"
                                                            className="form-control border-primary-subtle"
                                                            placeholder="Last Name"
                                                            {...register(`owners.${index}.lastname`, {
                                                                required: "Last Name required",
                                                                // pattern: {
                                                                //     value: /^[A-Za-z]{1,30}$/,
                                                                //     message: "Last name must be letters with no spaces, numbers, or special characters.",
                                                                // },
                                                                minLength: {
                                                                    value: 1,
                                                                    message: "Last Name must have at least 1 characters.",
                                                                },
                                                                maxLength: {
                                                                    value: 30,
                                                                    message: "Last Name must have a maximum of 30 characters.",
                                                                },
                                                            })}
                                                        />
                                                        {errors.owners?.[index]?.lastname && (
                                                            <span className="text-danger">{errors.owners[index].lastname.message}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col md={1}>
                                            <FormGroup>
                                                <Button color="danger" outline size="sm" type="button" onClick={() => remove(index)}>
                                                    <FaTrashAlt  />
                                                </Button>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                ))}

                                {/* add owners button */}
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Button 
                                            disabled={1 + fields.length >=3}
                                            onClick={()=>{
                                                append({firstname:"",middlename:"",lastname:""})
                                            }} type="button" className='btn py-2' style={{backgroundColor:"#00ADF0", color:"white"}}>Add Owners</Button>
                                            {1 + fields.length >= 3 && (
                                                <p className="text-muted mt-2 small">Maximum of 3 owners reached.</p>
                                            )}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    <Row>
                        <Col  md={9}>
                            <FormGroup>
                                <Label htmlFor='borrowername' className='form-label'>Borrower/Applicant Name</Label>
                                    <input
                                        type='text'
                                        className={`form-control border-primary-subtle ${isSameOwner ? 'bg-light text-muted' : ''}`}
                                        id='borrowername'
                                        name='borrowername'
                                        placeholder='Borrower/Applicant Name'
                                        {...register("borrowername",{
                                            required: !isSameOwner && "Borrower/Applicant Name Required"
                                        })}
                                        disabled={isSameOwner}
                                    />
                                    {errors.borrowername && <span className="text-danger">{errors.borrowername.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col md={3} className='d-flex align-items-center'>
                            <FormGroup check>
                                    <div className='d-flex align-items-center gap-2 mt-3'>
                                        <input
                                        type='checkbox'
                                        className='form-check-input'
                                        id='issameasowner'
                                        name='issameasowner'
                                        style={{ width: '20px', height: '20px'}}
                                       
                                        {...register("issameasowner",{
                                            onChange:(e)=>setIsSameOwner(e.target.checked)
                                        })}
                                    />
                                    <Label htmlFor='issameasowner' className='form-label mb-0'>Same as Current Owner</Label>

                                    </div>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row className='gx-2'>
                        <div className='mb-4 border-bottom pb-2'>
                            <h5 className='fw-bold'>Property Address Details</h5>
                        </div>
                        
                        <Col sm={2}>
                                <FormGroup>
                                    <Label htmlFor='streetnumber' className='form-label'>Street Number</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='streetnumber'
                                        name='streetnumber'
                                        placeholder='Street Number'
                                        {...register("streetnumber",{required:"Street Number Required",
                                            pattern:{value: /^[0-9]+[A-Za-z]?$|^[A-Za-z][0-9]+$/, message:"Street number must begin with digits optionally followed by a single letter, or start with a letter followed by digits."},
                                            minLength:{value:1,message:"Street number must have atleast 1 character."}
                                        })}
                                    />
                                    {errors.streetnumber && <span className="text-danger">{errors.streetnumber.message}</span>}
                                </FormGroup>
                            </Col>
                            <Col sm={2}>
                                <FormGroup>
                                    <Label htmlFor='streetprefix' className='form-label'>Street Prefix</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='streetprefix'
                                        name='streetprefix'
                                        placeholder='Street Prefix'
                                        {...register("streetprefix",{
                                            minLength:{value:1,message:"Prefix must have atleast 1 character."},
                                            maxLength:{value:2,message:"Street Prefix must have maximun 2 characters"},
                                            pattern:{value: /^(N|S|E|W|NE|NW|SE|SW)$/,message:"Prefix must be a valid direction."}
                                        })}
                                    />
                                    {errors.streetprefix && <span className="text-danger">{errors.streetprefix.message}</span>}
                                </FormGroup>
                            </Col>
                            <Col sm={5}>
                                <FormGroup>
                                    <Label htmlFor='streetname' className='form-label'>Street Name</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='streetname'
                                        name='streetname'
                                        placeholder='Street Name'
                                        {...register("streetname",{required:"Street Name Required",
                                            minLength:{value:2,message:"Street Name must have atleast 2 characters."},
                                            maxLength:{value:50,message:"Street Name must have maximum 50 characters."},
                                            pattern:{value: /^[A-Za-z0-9](?:[A-Za-z0-9\s]{0,48}[A-Za-z0-9])?$/, message:"Street name must contain only letters, numbers, and spaces."}
                                        })}
                                    />
                                    {errors.streetname && <span className="text-danger">{errors.streetname.message}</span>}
                                </FormGroup>
                            </Col>
                            <Col sm={1}>
                                    <FormGroup>
                                    <Label htmlFor='streettype' className='form-label'>Street Type</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='streettype'
                                        name='streettype'
                                        placeholder='Street Type'
                                        {...register("streettype",{
                                            minLength:{value:2,message:"Street Type must have atleast 2 characters."},
                                            maxLength:{value:20,message:"Street Type must have maximum 12 characters."},
                                            // pattern:{value: /^(Street|St|Avenue|Ave|Boulevard|Blvd|Road|Rd|Drive|Dr|Lane|Ln|Court|Ct|Place|Pl|Terrace|Ter|Circle|Cir|Way|Parkway|Pkwy|Highway|Hwy|Trail|Trl|Square|Sq|Loop)$/i,message:"Please provide a valid street type (e.g., Street, St, Avenue, Ave, Boulevard, Blvd, etc.) without any leading or trailing whitespace."}
                                        })}
                                    />
                                    {errors.streettype && <span className="text-danger">{errors.streettype.message}</span>}
                                </FormGroup>
                            </Col>
                            <Col sm={1}>
                                <FormGroup>
                                    <Label htmlFor='streetsuffix' className='form-label'>Street Suffix</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='streetsuffix'
                                        name='streetsuffix'
                                        placeholder='Street Suffix'
                                        {...register("streetsuffix",{
                                            minLength:{value:1,message:"Suffix must have atleast 1 character."},
                                            maxLength:{value:2,message:"Suffix must have maximun 2 characters"},
                                            pattern:{value: /^(N|S|E|W|NE|NW|SE|SW)$/,message:"Suffix must be a valid direction."}
                                        })}
                                    />
                                    {errors.streetsuffix && <span className="text-danger">{errors.streetsuffix.message}</span>}
                                </FormGroup>
                            </Col>
                            <Col sm={1}>
                                <FormGroup>
                                    <Label htmlFor='unit' className='form-label'>Unit</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='unit'
                                        name='unit'
                                        placeholder='Unit'
                                        {...register("unit",{
                                            pattern:{value: /^(Apt|Suite|Unit)?\s?#?\d+[A-Za-z]?$/, message:"Please enter a valid unit designation (e.g., Apt 101, Suite 3B, #12, or 12A) using only standard labels (Apt, Suite, Unit) and ensure there are no leading or trailing spaces."},
                                            minLength:{value:1,message:"Unit must have atleast 1 value."},
                                            maxLength:{value:15,message:"Unit must have maximum 15 value."}
                                        })}
                                    />
                                    {errors.unit && <span className="text-danger">{errors.unit.message}</span>}
                                </FormGroup>
                            </Col>
                    </Row>

                    <Row>
                        <Col>
                            <FormGroup>
                                    <Label htmlFor='city' className='form-label'>City</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='city'
                                        name='city'
                                        placeholder='City'
                                        {...register("city",{required:"City is Required",
                                            minLength:{value:2, message:"City must have atleast 2 characters."},
                                            maxLength:{value:50, message:"City must have maximum 50 characters."},
                                            pattern:{value: /^[A-Za-z](?:[A-Za-z\s\-']{0,48}[A-Za-z])?$/, message:"Please enter a valid city name using letters, spaces, hyphens, or apostrophes. Leading or trailing special characters are not allowed."}
                                        })}
                                    />
                                    {errors.city && <span className="text-danger">{errors.city.message}</span>}
                                </FormGroup>
                        </Col>
                        <Col>
                                <FormGroup>
                                    <Label htmlFor='state' className='form-label'>State</Label>
                                    <select
                                        className='form-select border-primary-subtle'
                                        id='state'
                                        name='state'
                                        defaultValue=""
                                        {...register("state",{required:"State is Required"})}
                                    >
                                        <option value="" disabled>Select State</option>
                                        {states.map((state,index)=>(
                                            <option key={index} value={state.id}>{state.state_code}</option>
                                        ))}
                                    </select>

                                    {errors.state && <span className="text-danger">{errors.state.message}</span>}
                                </FormGroup>
                            </Col>

                            <Col>
                                <FormGroup>
                                    <Label htmlFor='zip' className='form-label'>Zip</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='zip'
                                        name='zip'
                                        placeholder='Zip'
                                        {...register("zip",{required:"Zip Required",
                                            minLength:{value:5, message:"Zip must have atleast 5 numbers."},
                                            maxLength:{value:10, message:"Zip must have maximum 10 numbers."},
                                            pattern:{value:/^(?!\s)[0-9]{5}(?:-[0-9]{4})?(?<!\s)$/, message:"Please enter a valid 5-digit ZIP code or ZIP+4 format. Only digits are allowed, with an optional hyphen followed by 4 digits."}
                                        })}
                                    />
                                    {errors.zip && <span className="text-danger">{errors.zip.message}</span>}
                                </FormGroup>
                            </Col>
                    </Row>

                    <Row>
                            <Col>
                                <FormGroup>
                                    <Label htmlFor='apn' className='form-label'>APN</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='apn'
                                        name='apn'
                                        placeholder='APN'
                                        {...register("apn")}
                                    />
                                    {errors.apn && <span className="text-danger">{errors.apn.message}</span>}
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label htmlFor='county' className='form-label'>County</Label>
                                    <select
                                        className='form-select border-primary-subtle'
                                        id='county'
                                        // name='county'
                                        // defaultValue=""
                                        {...register("county",{required:"County is Required"})}
                                    >
                                        <option value="" disabled>Select County</option>
                                        {counties.map((county,index)=>(
                                            <option key={county.id} value={county.id}>{county.county_name}</option>
                                        ))}
                                    </select>
                                    
                                    {errors.county && <span className="text-danger">{errors.county.message}</span>}
                                </FormGroup>
                            </Col>
                            <Col></Col>
                    </Row>
                    <Row>
                        <div className='mb-4 border-bottom pb-2' />
                        <Col>
                            <FormGroup>
                                <Button type='submit' className='btn w-100 py-2' style={{backgroundColor:"#00ADF0", color:"white"}}
                                    disabled={isPending || isEditing}
                                >
                                    {(isPending || isEditing) ? (
                                            <>
                                            <Spinner size="sm" className="me-2" />
                                            {isEditMode ? 'Updating...' : 'Creating...'}
                                            </>
                                        ) : (
                                            isEditMode ? 'Update Order' : 'Create Order'
                                        )}
                                </Button>
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    </Container>
  )
}

export default SingleOrderForm